import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Row,
  Accordion,
  Container,
} from "react-bootstrap";
import view from "../../../assets/images/icons/view.png";
import hidden from "../../../assets/images/icons/hidden.png";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { userUpdate } from "../../../utils/api";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import Pic from "../../../assets/images/icons/user.png";
import blog_card_img1 from "../../../assets/images/dummy/blog_card_img1.png";
import { useUserContext } from "../../../utils/hooks/UserContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addDays } from "date-fns";
import moment from "moment";
import axios from "axios";
import { useLocation } from "react-router-dom";
import SessionCss from "../../UserCss/session.css";
import Modal from "react-awesome-modal";

const baseURL = `${process.env.REACT_APP_LOCAL_BASE_URL}`;
const UserScheduleSessionComponent = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { sessionData } = location.state || {};
  console.log("sessionData", sessionData);

  const formatDuration = (totalMinutes) => {
    const days = Math.floor(totalMinutes / (24 * 60));
    const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
    const minutes = totalMinutes % 60;

    return [
      days > 0 ? `${days} day${days > 1 ? "s" : ""}` : "",
      hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}` : "",
      minutes > 0 ? `${minutes} min${minutes > 1 ? "s" : ""}` : "",
    ]
      .filter(Boolean) // Remove empty values
      .join(", ");
  };
  const { user } = useUserContext();
  const [bookedEvents, setBookedEvents] = useState([]);
  const [myCoachList, setMyCoachList] = useState([]);
  const [myProgramList, setMyProgramList] = useState([]);

  const [selectedDate, setSelectedDate] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [coachTimeZone, setCoachTimeZone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );
  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [availabilityId, setAvailabilityId] = useState("");
  const [programId, setProgramId] = useState("");
  const [coachId, setCoachId] = useState("");
  const [slotId, setSlotId] = useState("");
  const [scheduleDate, setScheduleDate] = useState("");
  const [programDuration, setProgramDuration] = useState(0);
  const [programType, setProgramType] = useState("");
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedItemIdSlot, setSelectedItemIdSlot] = useState(null);
  const getData = async () => {
    setAvailabilityId(
      sessionData.type === "multiple"
        ? sessionData.id
        : sessionData.schedule_type === "Reschedule"
        ? sessionData.id
        : sessionData?.session?.[0].id
    );
    setSelectedItemId(
      sessionData.type === "multiple"
        ? sessionData.id
        : sessionData?.session?.[0].id
    );
    setProgramId(sessionData.coach_program_id);
    setCoachId(sessionData.coach_id);
    setProgramDuration(sessionData.duration);
    setProgramType(sessionData.type);
    try {
      const listOption1 = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/users-slot-register-list?coach_id=${sessionData.coach_id}&program_id=${sessionData.coach_program_id}`,
      };
      axios(listOption1).then((resp) => {
        // console.log(resp, "users-slot-register-list");
        setMyProgramList(resp.data.data);
      });

      const listOptions = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/users-coach-list`,
      };
      axios(listOptions).then((resp) => {
        // console.log(resp, "resp");
        setMyCoachList(resp.data.data);
      });

      //   console.log(userSessions, "sessions"); // Check the response structure
    } catch (error) {
      //   console.error("Error fetching data:", error);
    }
  };
  const getListData = async () => {
    // console.log("useruseruseruser", user);
    try {
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/coach-booked-slot-list?type=user&coach_id=${sessionData.coach_id}&program_id=${programId}`,
      };
      axios(options).then((resp) => {
        // console.log(resp, "filter");
        if (resp.data.data.length > 0) {
          // resp.data.data = resp.data.data.map(element => {
          //   element.start_time= moment(element.start_time , "YYYY-MM-DD HH:mm:ss") // Parse the string
          //   .add(30, "minutes") // Add 40 minutes
          //   .add(6, "hours") // Add 2 hours
          //   .format('YYYY-MM-DD HH:mm:ss');
          //   element.end_time= moment(element.end_time , "YYYY-MM-DD HH:mm:ss") // Parse the string
          //   .add(30, "minutes") // Add 40 minutes
          //   .add(6, "hours") // Add 2 hours
          //   .format('YYYY-MM-DD HH:mm:ss');
          // });
          setBookedEvents(resp.data.data);
        }
        filterDataByDate(startDate);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const programSelection = async (
    availabilityId,
    programId,
    coachId,
    duration,
    type
  ) => {
    console.log("3333", availabilityId, programId, coachId, duration, type);
    setAvailabilityId(availabilityId);
    setSelectedItemId(availabilityId);
    setProgramId(programId);
    setCoachId(coachId);
    setProgramDuration(duration);
    setProgramType(type);
    // setSlotId("");
    // setScheduleDate("");
  };
  useEffect(() => {
    getListData();
  }, [programId]);
  console.log("availabilityId", availabilityId);
  const selectTimeSlot = async (slot_id, date) => {
    setSlotId(slot_id);
    setSelectedItemIdSlot(slot_id);

    let s_date = moment.utc(date).format("YYYY-MM-DD HH:mm:ss");
    console.log("hererere", s_date, startDate);
    // console.log("Original UTC Date: ", moment.utc(date).format('YYYY-MM-DD HH:mm:ss'));
    // console.log("Adjusted Local Date: ", parsedDate.format('YYYY-MM-DD HH:mm:ss'));
    setScheduleDate(s_date);
  };
  const [visible, setVisible] = useState(false);
  const [totalDuration, setTotalDuration] = useState("");

  const getDurationById = (id) => {
    console.log("uuuu", id, bookedEvents);
    const event = bookedEvents.find((event) => event.id === slotId);
    console.log("event", event);
    if (!event) return null; // If event not found

    const start = new Date(event.start_time);
    const end = new Date(event.end_time);

    const durationMinutes = (end - start) / (1000 * 60); // Convert ms to minutes
    console.log("durationMinutes", durationMinutes);
    return durationMinutes;
  };
  const bookSlot = async (event) => {
    console.log(availabilityId, programId, coachId, slotId);
    event.preventDefault();
    // console.log(availabilityId, programId, coachId, slotId, scheduleDate);
    if (!availabilityId || !programId || !coachId || !slotId) {
      toast.error("please select program and slots");
    } else {
      let tDuration = await getDurationById(availabilityId);
      console.log("tDuration", tDuration);
      setTotalDuration(tDuration);
    }
  };

  useEffect(() => {
    if (totalDuration) {
      console.log("98989", totalDuration, programDuration);
      if (totalDuration == programDuration) {
        confirmSlot();
      } else {
        setVisible(true);
      }
    }
  }, [totalDuration]);
  const confirmSlot = async () => {
    try {
      const options = {
        method: "POST",
        headers: {
          "content-type": "application/json",
          token: localStorage.getItem("token"),
          "Cache-Control":
            "no-store, no-cache, must-revalidate, proxy-revalidate",
        },

        url: `${baseURL}/coach/program/user-slot-book`,
        data: {
          coach_id: coachId,
          program_id: programId,
          available_slot_id: slotId,
          schedule_date: scheduleDate,
          id: availabilityId,
          type: programType,
          schedule_type:
            sessionData?.schedule_type === "Reschedule"
              ? "Reschedule"
              : "schedule",
        },
      };
      axios(options).then((resp) => {
        // console.log(resp.data,resp.data.data)
        if (resp.data.status) {
          if (resp.data.data.length > 0) {
            setBookedEvents(resp.data.data);
          }
          // setBookedEvents(resp.data.data);
          toast.success(resp.data.message);
          setVisible(false);

          setTimeout(() => {
            navigate("/user/my-programs");
          }, 1000);
        } else {
          toast.error("Slot not booked!");
        }
      });
    } catch (error) {
      toast.error("Slot not booked!");

      // console.log(error);
    }
  };

  const [showDate, setDate] = useState("");

  const filterDataByDate = (selectedDate, endDate = null) => {
    // If selectedDate and endDate are the same, set endDate to null
    console.log("selectedDate", coachTimeZone);
    if (
      selectedDate &&
      endDate &&
      moment
        .tz(selectedDate, coachTimeZone)
        .isSame(moment.tz(endDate, coachTimeZone), "day")
    ) {
      endDate = null;
    }

    // Format for display
    const adjustedStartTime = moment.tz(selectedDate, coachTimeZone);
    const formattedStartTime = adjustedStartTime.format("dddd, MMMM DD");

    if (endDate) {
      const adjustedEndTime = moment.tz(endDate, coachTimeZone);
      const formattedEndTime = adjustedEndTime.format("DD MMM");
      setDate(`${adjustedStartTime.format("DD MMM")} - ${formattedEndTime}`);
    } else {
      setDate(formattedStartTime);
    }

    console.log("Dates being filtered:", { selectedDate, endDate });

    // Convert to start and end of day in user's timezone
    const startOfSelected = moment
      .tz(selectedDate, coachTimeZone)
      .startOf("day");
    const endOfSelected = endDate
      ? moment.tz(endDate, coachTimeZone).endOf("day")
      : moment.tz(selectedDate, coachTimeZone).endOf("day");

    // Filter the events
    const filtered = bookedEvents.filter((item) => {
      const startDateTime = moment.utc(item.start_time).tz(coachTimeZone);
      const endDateTime = moment.utc(item.end_time).tz(coachTimeZone);

      return (
        startDateTime.isSameOrBefore(endOfSelected) &&
        endDateTime.isSameOrAfter(startOfSelected)
      );
    });

    console.log("Filtered events:", filtered);

    const sortedFiltered = filtered.sort(
      (a, b) => new Date(a.start_time) - new Date(b.start_time)
    );
    setFilteredData(sortedFiltered);
  };

  useEffect(() => {
    filterDataByDate(startDate, endDate);
  }, [bookedEvents]);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setSlotId("");
    setScheduleDate("");
    if (start) {
      filterDataByDate(start, end); // Call the filter function with the selected start date
    } else {
      // setFilteredData(data); // Reset to original data if no date is selected
    }
  };
  console.log(filteredData, "filteredDatafilteredData");
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getListData();
  }, []);
  const defaultUserImage = (e) => {
    e.target.src = blog_card_img1;
  };

  return (
    <>
      <section className="py-3 white_bg py-lg-5">
        <Container className="">
          <Row className="g-5 justify-content-center">
            <Col lg="6">
              <div className="hdng_a">
                <h6 className="text-uppercase">Schedule Session</h6>
                <h2>Book Your Time Slot</h2>
              </div>
              {myProgramList?.length > 0 ? (
                myProgramList.map((item, index) => (
                  <div className="my-3 d-flex align-items-center" key={index}>
                    <span className="user_img">
                      <img
                        className="rounded-full w-[2.7rem] h-[2.7rem] object-cover"
                        src={
                          item.profile_pic
                            ? `${process.env.REACT_APP_COACH_PROFILE_FOLDER_PATH}${item.profile_pic}`
                            : Pic
                        }
                        alt="Coach Profile"
                      />
                    </span>
                    <div>
                      <h5 className="m-0 fs-14 fw-500">{item.coach_name}</h5>
                    </div>
                  </div>
                ))
              ) : (
                <p>No programs found.</p>
              )}

              <Accordion
                activeKey={myProgramList?.map((_, index) => index.toString())}
              >
                {myProgramList?.length > 0 ? (
                  myProgramList.map((item, programIndex) => (
                    <Accordion.Item
                      eventKey={programIndex.toString()}
                      key={programIndex}
                    >
                      <Accordion.Header>
                        <div className="my-3 w-100 pe-2">
                          <div className="d-flex w-100 justify-content-between align-items-center">
                            <p className="m-0 fs-12 fw-600">
                              {item.type === "single"
                                ? `${formatDuration(item.duration || 0)}`
                                : `${item.duration || 0} Days`}
                            </p>
                          </div>
                          <div className="d-flex w-100 justify-content-between align-items-center text-end">
                            <h5 className="m-0 text_brand_color2">
                              {item.session_title}
                            </h5>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        {item.session?.length > 0 ? (
                          item.session.map((sessionItem, sessionIndex) => {
                            const isDisabled =
                              sessionData.schedule_type === "Reschedule"
                                ? false
                                : sessionItem.session_day_status ===
                                    "scheduled" ||
                                  sessionItem.session_day_status ===
                                    "completed" ||
                                  sessionItem.session_day_status === "live";
                            console.log(availabilityId, sessionItem.id);
                            return (
                              <div
                                key={sessionIndex}
                                className={`schedule_session_slot_card ${
                                  availabilityId === sessionItem.id
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() => {
                                  if (!isDisabled) {
                                    programSelection(
                                      sessionItem.id,
                                      sessionItem.program_id,
                                      sessionItem.coach_id,
                                      sessionItem.duration,
                                      item.type
                                    );
                                  }
                                }}
                              >
                                <div className="d-flex w-100 justify-content-between align-items-center">
                                  <div>
                                    <h6 className="mb-1 fs-12 fw-500 text_brand_color2">
                                      {sessionItem.session_title}
                                    </h6>
                                    <p className="m-0 fs-12 fw-500">
                                      {formatDuration(sessionItem.duration)}
                                    </p>
                                  </div>
                                  <div>
                                    <p className="mb-1 fs-12 fw-500">
                                      {sessionItem.session_day_status}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p>No sessions found.</p>
                        )}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))
                ) : (
                  <p>No programs found.</p>
                )}
              </Accordion>

              {/* <Button className="mt-3" variant="success">Book Session</Button> */}
            </Col>
            {/* <h6>Schedule Session</h6>
            <h5 className="mb-4">Select Program To Book Your Time Slot</h5>
            <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
              {myProgramList.length > 0 ? (
                myProgramList.map((item, index) => (
                  <li key={index} style={{ marginBottom: "10px" }}>
                    <div
                      className={`booking_user_card ${
                        selectedItemId === item.id ? "selected" : ""
                      }`} // Apply 'selected' class if item is selected
                      onClick={() =>
                        programSelection(
                          item.id,
                          item.program_id,
                          item.coach_id,
                          item.duration,
                          item.type
                        )
                      } // Handle click
                    >
                      <Row className="align-items-center">
                        <Col sm="6">
                          <div className="p-2 booking_user_card_lt">
                            <div className="d-flex align-items-center">
                              <div className="ps-2">
                                <p>{item.session_title}</p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </li>
                ))
              ) : (
                <li>No programs available</li>
              )}
            </ul> */}
            <Col lg="6" className="py-4 bg-body-tertiary rounded-xl">
              <Form className="session-schedule-user">
                <div className="row">
                  <div className="col-md-12">
                    <div className="flex flex-col w-full gap-2">
                      <label className="font-medium form-label fs-14">
                        Select a Date & Time
                      </label>
                      {/* <input type="date" data-date-inline-picker="true" className="form-control" /> */}
                      <div className="w-full flex justify-center rounded-xl p-3 bg-[#fbf3e462] mx-auto">
                        <DatePicker
                          selected={startDate}
                          // onChange={onChange}
                          startDate={startDate}
                          endDate={endDate}
                          // value={selectedDate}
                          onChange={handleDateChange}
                          // excludeDates={[addDays(new Date(), 1), addDays(new Date(), 5)]}
                          selectsRange
                          inline
                        />
                      </div>
                    </div>
                    <div className="">
                      <label className="form-label fs-14">Time Zone</label>
                      <select className="form-control ms-0 fs-14">
                        <option>Indian Standard Time (+05:30)</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <label className="mt-4 form-label fs-12">{showDate}</label>
                    <div className="grid grid-cols-12 gap-3 mt-3">
                      {filteredData.map((item, index) => {
                        const adjustedTime = moment
                          .utc(item.start_time)
                          .tz(coachTimeZone);
                        const adjustedEndTime = moment
                          .utc(item.end_time)
                          .tz(coachTimeZone);

                        const formattedStartTime =
                          adjustedTime.format("HH:mm A");
                        const formattedEndTime =
                          adjustedEndTime.format("HH:mm A");

                        const result = `${adjustedTime.format(
                          "DD MMM"
                        )}, ${formattedStartTime} - ${formattedEndTime}`;

                        // Check if end_time is in the past in the user's timezone
                        const isExpired = adjustedEndTime.isBefore(
                          moment.tz(coachTimeZone)
                        );
                        return (
                          <div
                            className="col-span-12 md:col-span-4"
                            key={index}
                          >
                            {/* Conditionally render the label only for the first item */}

                            <input
                              type="checkbox"
                              className="d-none"
                              id={`checkbox-${index}`}
                              name={`checkbox-${index}`}
                              value={formattedStartTime}
                              onClick={() =>
                                selectTimeSlot(item.id, item.start_time)
                              }
                              disabled={isExpired} // Disable if expired
                            />

                            <label
                              htmlFor={`checkbox-${index}`}
                              className={`check-box-btn ${
                                selectedItemIdSlot === item.id
                                  ? "active border-1"
                                  : ""
                              } ${isExpired ? "disabled" : ""}`}
                            >
                              {result}
                            </label>
                          </div>
                        );
                      })}
                      {filteredData.length === 0 && (
                        <div className="col-span-12 mt-3 text-center">
                          <p className="m-0 mb-4 font-bold text-center fs-20">
                            No slots available!!
                          </p>
                        </div>
                      )}

                      {/* <label className="form-label fs-14">Tuesday, July 16</label>
                                        <div>
                                            <input type="checkbox" className="d-none" id="eight" name="eight" value="08:00 am" />
                                            <label for="eight" className="check-box-btn"> 08:00 am</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" className="d-none" id="ten" name="ten" value="10:00 am" />
                                            <label for="ten" className="check-box-btn"> 10:00 am</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" className="d-none" id="three" name="three" value="03:00 pm" />
                                            <label for="three" className="check-box-btn"> 03:00 pm</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" className="d-none" id="four" name="four" value="04:00 pm" />
                                            <label for="four" className="check-box-btn active"> 04:00 pm</label>
                                        </div>
                                        <div>
                                            <input type="checkbox" className="d-none" id="five" name="five" value="05:00 pm" />
                                            <label for="five" className="check-box-btn"> 05:00 pm</label>
                                        </div> */}
                    </div>
                  </div>
                </div>
                <button
                  className="mt-2 fs-14 btn btn-success btn-md w-100"
                  onClick={bookSlot}
                >
                  Confirm Slot
                </button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
      <Modal
        visible={visible}
        onClickAway={() => setVisible(false)}
        height="250px"
        width="600px"
      >
        <div className="text-center logout_modal position-absolute start-50 top-50 translate-middle">
          <p>
            {" "}
            Are you sure <br />
            You want to scheduled this slot because your program duration is{" "}
            {programDuration} Mins and you have selected slots for{" "}
            {totalDuration} Mins?
          </p>
          <div className="mt-4 logout_button_container">
            <button
              className="p-2 rounded btn-success me-3"
              onClick={() => {
                confirmSlot();
                // setVisible(false);
              }}
            >
              {" "}
              <h5 className="px-4 m-0 fs-14 fw-400">Yes</h5>{" "}
            </button>
            <button
              className="p-2 text-white border-0 rounded btn-success bg-secondary"
              onClick={() => setVisible(false)}
            >
              {" "}
              <h5 className="px-4 m-0 fs-14 fw-400">No</h5>{" "}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UserScheduleSessionComponent;
